import Links from "assets/files/Links.json"

export function GetLinksData() {
    return Links;
}